// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-124ebe00]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.blue-subtitle[data-v-124ebe00]{color:#1b56a6}h3[data-v-124ebe00]{font-style:normal;margin-bottom:5px}.margin[data-v-124ebe00]{margin-top:-35px}div[data-v-124ebe00]{padding:20px}#professional-ISI[data-v-124ebe00]{font-size:14px!important}", ""]);
// Exports
module.exports = exports;
